import { useEffect, useState, useRef, memo } from 'react'
import { createPortal } from 'react-dom'
import styles from './SpechopsAnimation.module.css'

const SpechopsAnimation = memo(function SpechopsAnimation({
  autoPlay = true,
  play,
  stop,
  onAnimationComplete,
}: {
  autoPlay?: boolean
  play?: boolean
  stop?: boolean
  onAnimationComplete?: () => void
}) {
  const [animationState, setAnimationState] = useState(
    autoPlay ? 'playing' : 'idle'
  )
  const [crypticCode, setCrypticCode] = useState('')
  const containerRef = useRef(null)
  const timeoutIds = useRef([])
  console.log('animationState', animationState)
  console.log('rerendered SpechopsAnimation')

  const handleAnimationEnd = () => {
    if (containerRef.current) {
      containerRef.current.classList.add(styles.flash)
    }

    const glitchStartId = setTimeout(() => {
      if (containerRef.current) {
        containerRef.current.classList.add(styles.glitchAnimation)
      }
    }, 400) // Start glitch animation right after the flash

    const animationFinishId = setTimeout(() => {
      setAnimationState('finished')
      timeoutIds.current.forEach(clearTimeout)
      timeoutIds.current = []

      // Call the callback when animation is complete
      if (onAnimationComplete) {
        onAnimationComplete()
      }
    }, 820) // 400ms for flash + 420ms for glitch

    timeoutIds.current.push(glitchStartId, animationFinishId)
  }

  useEffect(() => {
    const container = containerRef.current

    if (animationState === 'playing') {
      // Start the animations after a short delay
      const animateTimeoutId = setTimeout(() => {
        if (container) {
          container.classList.add(styles.animate)
        }
      }, 50)
      timeoutIds.current.push(animateTimeoutId)
    }

    const generateCrypticCode = () => {
      const characters = '1234567890abcdef'
      let result = ''
      for (let i = 0; i < 12; i++) {
        if (i === 6) {
          result += ' : '
        } else if (i > 0 && i % 2 === 0) {
          result += ' '
        }
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        )
        result += characters.charAt(
          Math.floor(Math.random() * characters.length)
        )
      }
      return result
    }

    const flashAndEnd = () => {
      if (container) {
        container.classList.add(styles.flash)
      }

      const CrypticCodeTimeoutId = setTimeout(() => {
        setCrypticCode(generateCrypticCode())
        if (container) {
          container.classList.add(styles.showCryptic)
        }
      }, 100)
      timeoutIds.current.push(CrypticCodeTimeoutId)

      // Wait for 3 seconds after the flash before ending the animation
      const delayFinishTimeoutId = setTimeout(() => {
        if (handleAnimationEnd) handleAnimationEnd()
      }, 3100)
      timeoutIds.current.push(delayFinishTimeoutId)
    }

    const animationDuration = 3550
    if (animationState === 'playing') {
      const timeoutId = setTimeout(handleAnimationEnd, animationDuration)
      timeoutIds.current.push(timeoutId)
    }
    return () => {
      timeoutIds.current.map((item) => {
        clearTimeout(item)
      })
      timeoutIds.current = []
    }
  }, [])

  return (
    animationState === 'playing' &&
    createPortal(
      <div
        ref={containerRef}
        className={`${styles.container}`}
        onClick={handleAnimationEnd}
      >
        <div className={styles.content}>
          <div className={styles.logoBg}></div>
          <div className={styles.textContainer}>
            <div className={styles.text}>
              {'SPECHOPS'.split('').map((letter, index) => (
                <span
                  key={index}
                  className={`${styles.letter} ${styles[`letter${index}`]}`}
                >
                  {letter}
                </span>
              ))}
            </div>
            {/* <div className={styles.crypticCode}>{crypticCode}</div> */}
          </div>
        </div>
      </div>,
      document.body
    )
  )
})

export default SpechopsAnimation
